import { z } from "zod";

import { getSanitizedData } from "@/utils/getSanitizedData";

export const sendTestimonyBaseSchema = z.object({
  witness: z.string().min(1, { message: "Le témoin est obligatoire" }),
  description: z
    .string()
    .min(1, { message: "Le témoignage est obligatoire" })
    .min(5, { message: "Le témoignage doit contenir au moins 5 caractères" })
    .max(550, {
      message: "Le témoignage ne peut pas dépasser 550 caractères",
    })
    .transform((val) => getSanitizedData(val || "")),
  cgu: z.boolean().refine((val) => val === true, {
    message: "Vous devez accepter les conditions",
  }),
});

export const sendTestimonySchema = sendTestimonyBaseSchema;

/**
 * Type for API submission (server-side)
 * Excludes form-specific fields not needed for API
 */
export type SendTestimonyApiData = Omit<
  z.infer<typeof sendTestimonySchema>,
  "witness" | "cgu" | "description"
>;

/**
 * Type for the complete form data (client-side)
 * Includes all fields needed for form validation
 */
export type SendTestimonyFormValues = z.infer<typeof sendTestimonySchema>;
